export const getVerificationCode = (search = "") => {
  const query = new URLSearchParams(search);
  return (
    query.get("validateCode") ||
    query.get("verToken") ||
    query.get("code") ||
    null
  );
};
